import './App.css';
import axios from "axios";

import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Home from "./components/home/Home";
import Portfolio from "./components/portfolio/Portfolio";
import Experience from "./components/experience/Experience";
import Skills from "./components/skills/Skills";
import Sidebar from "./components/sidebar/Sidebar";
import Education from './components/education/Education';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

function App() {
  return (
    <>
      <Sidebar />
      <main className='main'>
        <Home />
        <About />
        <Education />
        <Experience />
        <Portfolio />
        <Skills />
        <Contact />
      </main>
    </>
  );
}

export default App;